module.exports = __webpack_public_path__ + "img/1-3.5d2720b1.jpg";